import React, { useEffect, useState, useContext } from 'react';
import Modal from 'react-modal';
import { CartContext } from './CartContext';
import { FiShoppingCart } from 'react-icons/fi';
import axios from 'axios';
import './reviews.css';

const Reviews = (props) => {
    const { ProductId } = props;
    const { apiUrl, STORE_ID } = useContext(CartContext);
    const [reviews, setReviews] = useState([]);
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    
    useEffect(() => {
        fetchReviews(currentPage);
    }, [currentPage]); // Re-fetch reviews when the currentPage changes

    const fetchReviews = (page) => {
        let formData = new FormData();
        formData.append('action', 'getReviews');
        formData.append('store_id', STORE_ID);
        formData.append('product_id', ProductId);
        formData.append('page', page);

        axios
            .post(apiUrl, formData)
            .then((response) => {
                let { success, data } = response.data;
                if (success) {
                    let total_pages = data[0].total_pages;
                    setReviews(data);
                    setTotalPages(total_pages);
                }
            })
            .catch((error) => {
            });
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const renderRatingStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            const starClassName = i <= rating ? 'star filled' : 'star';
            stars.push(<span className={starClassName} key={i}>&#9733;</span>);
        }
        return stars;
    };

    const formatReviewDate = (dateStr) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateStr);
        return date.toLocaleDateString(undefined, options);
    };

    return (
        <div>
            {reviews.map((review) => (
                <div className="review" key={review.review_id}>
                    <div className="review-author">{review.reviewer_name}</div>
                    <div className="review-rating">
                        {renderRatingStars(review.review_rating)}
                    </div>
                    <div className="review-content">{review.review_text}</div>
                    <div className="review-location">{review.review_location}</div>
                    <div className="review-date">
                        {formatReviewDate(review.review_date)}
                    </div>
                </div>
            ))}
            <div className="pagination">
                {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
                    <button
                    key={pageNumber}
                    className={pageNumber === currentPage ? 'active' : ''}
                    onClick={() => handlePageChange(pageNumber)}
                    >
                    {pageNumber}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Reviews;